import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../../api';
import { checkBookingApiV2 } from '../../../api/booking';
import { BookingState, ParamsCheckBookingV2 } from '../../../types/booking';
import { RootState } from '../../store';

export const getCheckBookingV2 = createAsyncThunk(
  'admin/check-booking-v2',
  async (params: ParamsCheckBookingV2, { dispatch, rejectWithValue }) => {
    try {
      const response = await checkBookingApiV2(params);
      const { status } = response;
      if (status) {
        dispatch(setUpdate(response));
      }
      return true;
    } catch (error: any) {
      const { response } = error;
      dispatch(setUpdateError(response));
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
export const checkBookingSlice = createSlice({
  name: 'check-booking-v2',
  initialState: {
    error: false,
    loading: false,
    success: false,
    status: 0,
    message: '',
    listDataSegmentBooking: [],
    errorDetail: null,
  } as BookingState,
  reducers: {
    setUpdate: (state: BookingState, { payload }) => {
      state.listDataSegmentBooking = payload?.data?.data;
      state.status = payload?.status;
    },
    setUpdateError: (state: BookingState, { payload }) => {
      const { errors } = payload.data;
      state.status = payload?.status;
      state.errorDetail = errors;
    },
    resetCheckBookingSegment: (state: BookingState) => {
      state.success = false;
      state.message = '';
      state.errorDetail = null;
      state.status = 0;
      state.listDataSegmentBooking = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCheckBookingV2.pending, (state: BookingState) => {
      state.loading = true;
      state.success = false;
    });
    builder.addCase(getCheckBookingV2.fulfilled, (state: BookingState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getCheckBookingV2.rejected, (state: BookingState, { payload }) => {
      state.loading = false;
      state.success = false;
      state.error = true;
      state.message = payload;
    });
  },
});

export const checkBookingSelector = (state: RootState) => state.checkBooking;
export const { setUpdateError, setUpdate, resetCheckBookingSegment } = checkBookingSlice.actions;
